module.exports = __webpack_public_path__ + "img/tao.0846b23d.png";